import { Box, Skeleton } from '@mui/material'
import { useState, useCallback } from 'react'
import { ifEnter } from '../../../utils'
import { IconButton, LeafIcon } from '@thriveglobal/thrive-web-leafkit'
import getBackgroundImageSize from '../../../utils/images/getBackgroundImageSize'

interface Props {
    thumbnail?: string
    showLoading?: boolean
    playIconFontSize?: string
    title?: string
    height?: string | number
    width?: string | number
    onPlay?: () => void
}

export default function VideoPlayerThumbnail({
    thumbnail,
    title = '',
    showLoading,
    height = '100%',
    width = '100%',
    playIconFontSize = '24px',
    onPlay
}: Props) {
    const [hovering, setHovering] = useState(false)
    const handleMouseEnter = useCallback((e: any) => {
        setHovering(true)
    }, [])

    const handleMouseLeave = useCallback((e: any) => {
        setHovering(false)
    }, [])

    // BUG: getBackgroundImageSize is a hook; it should be called inside a conditional statement.
    const backgroundImageSize = getBackgroundImageSize({
        imageSrc: thumbnail ?? ''
    })

    const backgroundSize = thumbnail ? backgroundImageSize : 'cover'

    return (
        <Box
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            sx={{
                height,
                width,
                background: `url(${thumbnail}) no-repeat center top`,
                backgroundSize: backgroundSize
            }}
        >
            {showLoading ? (
                <Skeleton variant="rectangular" height={height} width={width} />
            ) : (
                <Box
                    sx={{
                        width,
                        height,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: hovering ? '#00000057' : undefined,
                        transition: 'background-color 0.5s'
                    }}
                >
                    {onPlay && (
                        <IconButton
                            data-testid={`play-${title}`}
                            onClick={onPlay}
                            onKeyDown={ifEnter(onPlay)}
                            sx={{ mr: 0.5 }}
                            color={'info'}
                        >
                            <LeafIcon icon={'circle-play'} />
                        </IconButton>
                    )}
                </Box>
            )}
        </Box>
    )
}
